export default __webpack_public_path__ + "static/media/intro-scene-mountains.cbd2943e.webp";